import GraphQLModel from '../../graphQLModel'
import toSnakeCase from '../../../util/toSnakeCase'
import DiscourseResult from './result'
import { gql } from '@polleverywhere/graphql-client'

const updateVote = gql`
  mutation updateVote($input: DiscourseVoteInput!) {
    updateVote(input: $input) {
      result {
        netVotes
      }
      value
    }
  }
`

export default class DiscourseVote extends GraphQLModel {
  preinitialize (attrs = {}, options = {}) {
    /**
     * Hold reference to parent result this vote belongs to. Every result has at
     * most a single vote model associated with it based on `result_id`.
     * @type {DiscourseResult}
     */
    if (options.result instanceof DiscourseResult) {
      this.result = options.result
    } else {
      this.result = new DiscourseResult(options.result || {})
    }
  }

  getQuery (action) {
    switch (action) {
      case 'create':
        return {
          action: 'mutate',
          parse: (json) => toSnakeCase(json.updateVote),
          query: updateVote,
          variables: {
            input: {
              participantKey: this.result.poll().get('participant_key'),
              resultId: this.result.id,
              value: this.get('value')
            }
          }
        }
      default:
        throw new Error(`Unknown query for ${action}`)
    }
  }

  parse (data = {}, options = {}) {
    if (data.result) {
      // Copy the ID to our own attribute, so you can find results by
      // `votes.find({ result_id: self.model.id })`
      if (data.result.id) {
        data.result_id = data.result.id
      }

      // Set the full result data
      this.result.set(data.result)
      delete data.result
    }

    return super.parse(data, options)
  }
}
